import { render, staticRenderFns } from "./project-conversation-panel.vue?vue&type=template&id=11ac1870&scoped=true"
import script from "./project-conversation-panel.vue?vue&type=script&lang=js"
export * from "./project-conversation-panel.vue?vue&type=script&lang=js"
import style0 from "./project-conversation-panel.vue?vue&type=style&index=0&id=11ac1870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../mnt/host/d/wwwroot/deepcityAI/user-client-pc/user-client-common-pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ac1870",
  null
  
)

export default component.exports